var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"news-list"},[_c('Banner',{attrs:{"banner":_vm.bannerSrc}}),_c('NewsList',{attrs:{"voteName":_vm.option.voteName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }